let env = process.env.REACT_APP_ENV
	? process.env.REACT_APP_ENV
	: process.env.NODE_ENV;

if (!env) {
	console.error('ENV: ', env);
	env = 'development';
}

let gameUrl = 'http://localhost:3000';
let apiURL = 'http://localhost:8080/api/';
let playersDbName = 'players';
if (env === 'test' || env === 'demo') {
	gameUrl = 'cgl-vikarproven-test.web.app';
	apiURL = 'https://cgl-vikarproven-test.web.app/api/';
	if (env === 'demo') {
		gameUrl = 'cgl-vikarproven-demo.web.app';
		apiURL = 'https://cgl-vikarproven-demo.web.app/api/';
		playersDbName = 'players-demo';
	}
}
if (env === 'production') {
	gameUrl = 'cgl-vikarproven-production.web.app';
	apiURL = 'https://cgl-vikarproven-production.web.app/api/';
}



const appConfig = {
	env,
	playersDbName,
	gameUrl,
	apiURL,	
	name: 'Vikarkøreprøven',
	adminUri: 'admin',
	screenBaseWidth: 1920,
	defaultLanguage: 'da',
	maxStarsPerModule: 3,
	inactivityLimitSeconds: 30
};

export default appConfig;